import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Swal from "sweetalert2";

const AccountSwitch = () => {
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedFullName, setSelectedFullName] = useState("");
  const [siblings, setSiblings] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Get saved siblings list from localStorage
    const storedSiblings = JSON.parse(localStorage.getItem("siblings")) || [];
    setSiblings(storedSiblings);

    // Auto-select current active user
    const activeUser = localStorage.getItem("activeUser");
    const activeFullName = localStorage.getItem("full_name");

    if (activeUser) {
      setSelectedAccount(activeUser);
      setSelectedFullName(activeFullName || "");
    }
  }, []);

  const handleSelection = (e) => {
    const [username, fullName] = e.target.value.split("|");
    setSelectedAccount(username);
    setSelectedFullName(fullName);
  };

//   const sendFcmToken = async (authToken) => {
//   try {
//     const fcmToken = localStorage.getItem("fcm_token");

//     if (!fcmToken) return;

//     await fetch("https://api.mirai.healthcare/api/user/fcm-token", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-auth": authToken,
//       },
//       body: JSON.stringify({
//         fcm_token: fcmToken,
//       }),
//     });

//     console.log("✅ FCM token updated successfully");
//   } catch (error) {
//     console.error("❌ FCM update error:", error);
//   }
// };

const sendFcmToken = async (authToken) => {
  try {
    const fcmToken = localStorage.getItem("fcm_token");

    console.log("📲 FCM from WebView:", fcmToken);

    if (!fcmToken) {
      console.warn("❌ No FCM token found");
      return;
    }

    await fetch("https://api.mirai.healthcare/api/user/fcm-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth": authToken,
      },
      body: JSON.stringify({
        fcm_token: fcmToken,
      }),
    });

    console.log("✅ FCM token updated successfully");
  } catch (error) {
    console.error("❌ FCM update error:", error);
  }
};

  const handleSubmit = async () => {
  if (!selectedAccount) {
    Swal.fire({
      icon: "warning",
      title: "Please select an account",
    });
    return;
  }

  const selectedSibling = siblings.find(
    (sib) =>
      sib.username === selectedAccount &&
      sib.full_name === selectedFullName
  );

  if (selectedSibling) {
    // 🔹 Update token
    localStorage.setItem("token", selectedSibling.token);
    localStorage.setItem("activeUser", selectedSibling.username);
    localStorage.setItem("full_name", selectedSibling.full_name);

    // ✅ 🔥 FCM TOKEN SEND AFTER SWITCH
    await sendFcmToken(selectedSibling.token);

    Swal.fire({
      icon: "success",
      title: "Switched to account",
      text: `${selectedSibling.full_name} (${selectedSibling.username})`,
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "/";
      }
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Selected account not found",
    });
  }
};

  return (
    <div className="page-wrapper">
      <div className="content" id="enquiry-content">
        <Header hideSearch={true} />

        <div className="row d-flex justify-content-center">
          <div className="col-xxl-3 col-xl-4">

            <div className="card shadow-sm border-0 mt-4">
              <div className="card-body">
                <h5 className="mb-3 fw-semibold">Select Account</h5>

                {siblings.length > 0 ? (
                  siblings.map((sib, index) => (
                    <div key={index} className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="account"
                        value={`${sib.username}|${sib.full_name}`}
                        id={`account-${index}`}
                        checked={selectedAccount === sib.username}
                        onChange={handleSelection}
                      />

                      <label
                        className="form-check-label ms-2"
                        htmlFor={`account-${index}`}
                      >
                        {sib.full_name} ({sib.username})
                        {sib.username === localStorage.getItem("activeUser") && (
                          <span className="text-success ms-2">(Current)</span>
                        )}
                      </label>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No sibling accounts found.</p>
                )}

                <button
                  className="btn btn-primary mt-3 w-100"
                  onClick={handleSubmit}
                >
                  Switch
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSwitch;
